import { render, staticRenderFns } from "./loadingcomp.vue?vue&type=template&id=4bd1c742&"
import script from "./loadingcomp.vue?vue&type=script&lang=js&"
export * from "./loadingcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports